module.exports = __webpack_public_path__ + "static/media/Close.e5e6751e.svg";